import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
export const TextArea = forwardRef(({ placeholder, value, onChange, onBlur, onFocus, disabled = false, size = 'medium', className = '', name, id, required, rows = 4, autoComplete, ...props }, ref) => {
    const sizeClass = `legarta-textarea--${size}`;
    return (_jsx(StyledTextArea, { ref: ref, placeholder: placeholder, value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, disabled: disabled, className: `legarta-textarea ${sizeClass} ${className}`, name: name, id: id, required: required, rows: rows, autoComplete: autoComplete, ...props }));
});
TextArea.displayName = 'TextArea';
const StyledTextArea = styled.textarea `
  width: 100%;
  border: 2px solid ${colors.borderMedium};
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.3s ease;
  background: ${colors.backgroundLight};
  color: ${colors.textPrimary};
  resize: vertical;
  min-height: 80px;

  &::placeholder {
    color: ${colors.textSecondary};
    opacity: 0.7;
  }

  &:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px ${colors.shadowPrimary}20;
  }

  &:hover:not(:focus) {
    border-color: ${colors.borderDark};
  }

  &:disabled {
    background: ${colors.backgroundLight};
    color: ${colors.textLight};
    cursor: not-allowed;
    border-color: ${colors.borderLight};
  }

  &.legarta-textarea--small {
    padding: 6px 12px;
    font-size: 13px;
  }

  &.legarta-textarea--medium {
    padding: 8px 16px;
    font-size: 14px;
  }

  &.legarta-textarea--large {
    padding: 12px 20px;
    font-size: 16px;
  }
`;
